module.exports = __webpack_public_path__ + "img/cover-course-v1.927c1f70.png";